import { ApiParamsChanged } from '@/constants/bus_event'
import objectUtil from '@/utils/object_util'

/**
 * 列表页搜索辅助
 */
export default {
  /**
   * @function emitApiParamsChanged
   * @description 基于当前路由 和 参数，请求加载 API。
   * 只有参数变化了，才会触发API加载（主要是为了防止多重刷新）。
   *
   * @param {object} bus 查询通讯的总线
   * @param {object} params 参数。Example { name: 'Joe' }
   * @param {string} sourceName 来源的名字。用于 log trace 谁触发的查询
   * @param {object} options 其他选项
   * @param {boolean} options.clearOtherParams 是否清空 $route 的其他参数。默认为 false
   */
  emitApiParamsChanged(bus, params = {}, sourceName = '', options = { clearOtherParams: false }) {
    if (bus === null) return

    let query = options.clearOtherParams ? {} : window.app.$route.query

    // 若不是翻页操作，将页码改为1
    // if (query.page && !params.page) {
    //   params.page = 1
    // }

    Object.keys(params).forEach(paramKey => {
      let paramValue = params[paramKey]
      if (objectUtil.isEmptyObject(paramValue)) {
        delete query[paramKey]
      } else {
        query[paramKey] = paramValue
      }
    })
    bus.$emit(ApiParamsChanged, query, sourceName, options)
  },
  /**
   * 更新 URL。一般是在搜索条件变更后执行
   *
   * @param {object} params 参数
   */
  updateUrl(params) {
    // 更新 $route.query
    window.app.$router.replace({ path: window.app.$route.path, query: params })

    // 更新 url
    let url = this._fullUrl(params)
    window.history.replaceState(null, url, url)
  },
  /**
   * 获取完整的 url
   *
   * @param {object} params 参数
   * @returns {string} 路径
   */
  _fullUrl(params) {
    let url = window.app.$route.path
    let query = []
    for (let property in params) {
      if (params[property]) {
        query.push(property + '=' + encodeURIComponent(params[property].toString()))
      }
    }

    if (query.length > 0) {
      url = url + '?' + query.join('&')
    }
    return url
  }
}
